module.exports = __webpack_public_path__ + "static/media/pet-size-final.6ec61900.svg";